import { useNotification } from '../../../../hooks'
import { parseServerValidation } from '../../../../utils/validation'
import { getCalendarSettingsPayload } from '../../CalendarSettings.utils'

export function useCalendarSettingsSubmit({ settings, onSave }) {
  const { handleAddSuccessNotification } = useNotification()

  async function handleSubmit(values, { resetForm, setErrors, setSubmitting }) {
    return onSave(getCalendarSettingsPayload({ settings, values }))
      .then(() => {
        resetForm({ values })

        handleAddSuccessNotification('Notification.CommonTitleChangedKey')
      })
      .catch(({ response }) => {
        setErrors(parseServerValidation(response?.data))
      })
      .finally(() => {
        setSubmitting(false)
      })
  }

  return { handleSubmit }
}
